// extracted by mini-css-extract-plugin
module.exports = {"devicesGridView":"DevicesGridView_devicesGridView__HYoFM","skeleton":"DevicesGridView_skeleton__1mzmS"};